{
  "title": "Language",
  "subtitle": "Choose the language Opncue uses. Your conversations are never translated.",
  "systemDefault": "System default",
  "systemDefaultDescription": "Match your device language. If it isn’t available yet, Opncue uses English.",
  "moreComing": "Translations may not always capture the exact meaning of the original."
}
